import type { CharacterAnimationAlias } from './types';

const BOARD_CAPE_HOVER_HEIGHT = 0.22;
const BOARD_CAPE_HOVER_BOB_AMPLITUDE = 0.035;
const BOARD_CAPE_HOVER_BOB_RADIANS_PER_SECOND = 0.8;

export function isFlyingBoardCharacter(capeNone: boolean | undefined): boolean {
  return capeNone === false;
}

export function getBoardCharacterHoverOffset(args: {
  readonly capeNone: boolean | undefined;
  readonly timeSeconds: number;
  readonly phase: number;
}): number {
  if (!isFlyingBoardCharacter(args.capeNone)) return 0;
  return (
    BOARD_CAPE_HOVER_HEIGHT +
    Math.sin(args.timeSeconds * BOARD_CAPE_HOVER_BOB_RADIANS_PER_SECOND + args.phase) *
      BOARD_CAPE_HOVER_BOB_AMPLITUDE
  );
}

export function selectBoardCharacterLocomotionAlias(args: {
  readonly capeNone: boolean | undefined;
  readonly moving: boolean;
}): CharacterAnimationAlias {
  return args.moving && !isFlyingBoardCharacter(args.capeNone) ? 'walk' : 'idle';
}

export function selectBoardCharacterWalkTurnAlias(args: {
  readonly capeNone: boolean | undefined;
  readonly turnDelta: number;
}): CharacterAnimationAlias | null {
  if (isFlyingBoardCharacter(args.capeNone)) return null;
  return args.turnDelta > 0 ? 'walkTurnRight' : 'walkTurnLeft';
}
